<template>
  <div class="building-container">
    <slot></slot>
  </div>
</template>
